import { ErrorBoundary } from "@components/ErrorBoundary/ErrorBoundary";

import { BoostCalloutBanner as BoostCalloutBannerInner } from "./BoostCalloutBanner";
import type { BoostCalloutBannerProps } from "./BoostCalloutBanner.types";

/** Shared booster banner wrapped in an error boundary. */
export const BoostCalloutBanner = (props: BoostCalloutBannerProps) => (
  <ErrorBoundary>
    <BoostCalloutBannerInner {...props} />
  </ErrorBoundary>
);

export type { BoostCalloutBannerProps } from "./BoostCalloutBanner.types";
